import { SET_ESS_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const essUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_ESS_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default essUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/ESS/reducer.js